import { createFileRoute, notFound } from '@tanstack/react-router'
import shareLinkConfig from '@/sharelinks.config.json'

export const Route = createFileRoute('/s/$shareId')({
  beforeLoad: async ({ params }) => {
    const { shareId } = params

    if (!shareId) {
      throw notFound()
    }

    const config = shareLinkConfig

    if (!config || !config.routes) {
      console.error('Share link configuration is missing or invalid.')
      throw notFound()
    }

    const firstLetter = shareId.charAt(0).toUpperCase()

    for (const route of config.routes) {
      if (route.prefix === firstLetter) {
        const targetUrl = route.targetPath.replace('[shareId]', shareId)
        throw new Response(null, {
          status: 302,
          headers: {
            Location: targetUrl,
          },
        })
      }
    }

    // If no prefix matches, treat as not found
    throw notFound()
  },
})
